<template>
  <page-layout
    :title="isEditPage ? 'setting.role_detail' : 'setting.add_new_role'"
  >
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title text-lg">
                {{ $t("setting.role_information") }}
              </h4>
            </div>
          </md-card-header>

          <md-card-content>
            <validation-form @on-submit="submitForm">
              <!-- form input -->
              <div class="form-input mb-10">
                <div class="md-layout mt-15">
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <validation-field
                      :validations="{ required: true }"
                      name="name"
                    >
                      <label>{{ $t("setting.role_name") }}</label>
                      <md-input
                        :readonly="isReadOnly"
                        required
                        v-model.trim="form.name"
                        :maxlength="255"
                      ></md-input>
                      <span class="md-error" v-if="serverValidations.name">{{
                        serverValidations.name
                      }}</span>
                    </validation-field>
                  </div>
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <md-field>
                      <label :for="select.name">{{ $t(select.label) }}</label>
                      <md-select
                        :disabled="isReadOnly"
                        :name="select.name"
                        :id="select.name"
                        v-model="form.status"
                        :multiple="select.multiple"
                      >
                        <!-- <md-option :value="''">--- All --</md-option> -->
                        <md-option
                          v-for="option in select.options"
                          :value="option.id"
                          :key="option.id + option.name"
                          >{{ $t(option.name) }}
                        </md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <md-field>
                      <label>{{ $t("common.description") }}</label>
                      <md-input
                        :readonly="isReadOnly"
                        v-model="form.description"
                      ></md-input>
                    </md-field>
                  </div>
                  <div
                    v-if="isEditPage"
                    class="md-layout-item md-size-33 md-small-size-100"
                  >
                    <label class="text-[#aaaaaa]">
                      {{ $t("setting.total_user") }}</label
                    >
                    <p class="pl-2 bg-[#c4c4c4]">
                      {{ form.count_user }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Form chexbox -->
              <div class="ml-4">
                <h3 class="permission-title">
                  {{ $t("setting.permission_setting") }}
                </h3>
                <p class="mt-2">
                  {{ $t("setting.apply_permission_for_this_role") }}
                </p>
                <md-checkbox
                  :disabled="isReadOnly"
                  v-model="isCheckedAllPermissions"
                  @change="selectAllPermissions"
                  >{{ $t("setting.all_privileges_shown_below") }}
                </md-checkbox>
                <div class="md-layout">
                  <p class="md-layout-item md-size-50 pb-2 pl-20">
                    {{ $t("setting.title") }}
                  </p>
                  <p class="md-layout-item md-size-50 pb-2">
                    {{ $t("setting.permission_level") }}
                  </p>
                </div>
                <md-table class="table-role">
                  <md-table-row
                    v-for="(permission, permissionKey) in permissions"
                    :key="permissionKey"
                  >
                    <md-table-cell class="pl-5"
                      ><span class="capitalize">{{ permissionKey }}</span>
                    </md-table-cell>
                    <md-table-cell
                      :class="idx === 1 ? 'br-1 pl-5' : 'pl-5'"
                      v-for="(item, idx) in permission"
                      :key="idx"
                    >
                      <md-checkbox
                        :disabled="isReadOnly"
                        v-model="item.isChecked"
                        @change="selectAllInline(permissionKey, idx)"
                        ><span class="capitalize">{{ item.name }}</span>
                      </md-checkbox>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </div>

              <!-- btn -->
              <div class="flex justify-center pt-10">
                <md-button class="md-raised mr-5" @click="goToPreviousPage"
                  >{{ $t("common.cancel") }}
                </md-button>
                <md-button
                  v-if="isEditPage && !isReadOnly"
                  type="submit"
                  class="md-success"
                  >{{ $t("common.update") }}
                </md-button>
                <md-button v-if="!isEditPage" type="submit" class="md-success"
                  >{{ $t("common.add") }}
                </md-button>
              </div>
            </validation-form>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </page-layout>
</template>
<script>
import PageLayout from "../PageLayout.vue";
import { service_paths } from "@/constants/Services";
import { hasHistory, genErrMsgOj, Message } from "@/helpers/utils";
import cloneDeep from "lodash/cloneDeep";
import pick from "lodash/pick";
import { RolePage } from "@/constants/Permissions";

export default {
  components: { PageLayout },
  props: ["formEdit", "isEditPage"],
  data() {
    return {
      form: {
        name: "",
        status: "Active",
        description: ""
      },
      permissions: [],

      isCheckedAllPermissions: false,
      serverValidations: {},
      select: {
        label: "common.status",
        name: "status__",
        value: "",
        type: "select",
        options: [
          {
            id: "Active",
            name: "common.active"
          },
          {
            id: "Inactive",
            name: "common.inactive"
          }
        ]
      }
    };
  },
  created() {
    this.initForm();
  },
  computed: {
    isReadOnly() {
      return (
        this.isEditPage && !this.$can(RolePage.actions.edit, RolePage.subject)
      );
    }
  },
  methods: {
    // check
    selectAllPermissions() {
      Object.values(this.permissions).forEach(pValue => {
        pValue.forEach(item => {
          item.isChecked = this.isCheckedAllPermissions;
        });
      });
    },
    selectAllInline(pName, index) {
      if (index === 0) {
        this.permissions[pName].forEach(item => {
          item.isChecked = this.permissions[pName][0].isChecked;
        });
      } else {
        let ischeckedAll = this.permissions[pName].find(
          item => item.isChecked === false && item.id
        );
        this.permissions[pName][0].isChecked = !ischeckedAll;
      }
      this.setCheckboxdAllPermissions();
    },
    setCheckboxdAllPermissions() {
      let isCheckedAll = true;
      Object.values(this.permissions).forEach(pValue => {
        pValue.forEach(item => {
          return (isCheckedAll *= item.isChecked);
        });
      });
      this.isCheckedAllPermissions = !!isCheckedAll;
    },

    // submit
    submitForm() {
      this.form.permission_ids = this.getPermissionIds();
      this.$emit("on-submit", this.form);
    },
    getPermissionIds() {
      const permissionIds = [];
      const permissions = cloneDeep(this.permissions);
      Object.values(permissions).forEach(pValue => {
        pValue.shift();
        pValue.forEach(item => {
          return item.isChecked === true ? permissionIds.push(item.id) : {};
        });
      });
      return permissionIds;
    },

    // init
    async initForm() {
      const permissionList = await this.fetchPermisson();
      Object.values(permissionList).forEach(pValue => {
        pValue.unshift({ name: this.$t("setting.select_all") });
        pValue.forEach(item => {
          return (item.isChecked = false);
        });
      });
      this.permissions = permissionList;
      this.isEditPage ? this.initFormEdit() : {};
    },

    initFormEdit() {
      this.form = pick(this.formEdit, Object.keys(this.formEdit));
      const permissionIds = this.formEdit.permission_ids;
      Object.values(this.permissions).forEach(pValue => {
        return pValue
          .filter(item => permissionIds.includes(item.id))
          .forEach(pValue => (pValue.isChecked = true));
      });
      this.setCheckboxAllInline();
      this.setCheckboxdAllPermissions();
    },
    setCheckboxAllInline() {
      Object.values(this.permissions).forEach(pValue => {
        let isCheckedAllInline = true;
        pValue.forEach((item, index) => {
          if (index !== 0) isCheckedAllInline *= item.isChecked;
        });
        pValue[0].isChecked = !!isCheckedAllInline;
      });
    },

    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    },

    async fetchPermisson() {
      let permissions = {};
      await this.$axios.get(service_paths.permissions).then(response => {
        permissions = response.data;
      });
      return permissions;
    }
  }
};
</script>

<style lang="scss">
.table-role {
  .permission-title {
    font-weight: 400;
    font-size: 20px;
    line-height: 23px;
  }
  .md-table-row {
    border: 1px solid #ddd;
  }
  .br-1 {
    border-left: 1px solid #ddd;
  }
  div.md-table-cell-container {
    min-width: 150px;
    min-height: 80px;
  }
}
</style>
